import {HttpServices} from "../Helpers";

export const GetAllUsersDropdown = async () => {
  return await HttpServices.get(
      `${process.env.REACT_APP_DOMIN_PHP_API_GET}/api/recruiter/${process.env.REACT_APP_VERSION_API}/users/dropdown`,
  )
      .then((data) => data)
      .catch((error) => error.response);
};

export const GetAllTimeZones = async ({limit = 100, company_uuid}) => {
  return await HttpServices.get(
      `${process.env.REACT_APP_DOMIN_PHP_API_GET}/api/helper/${process.env.REACT_APP_VERSION_API}/timezone`,
      {
        params: {
          limit,
          company_uuid,
        },
      }
  )
      .then((data) => data)
      .catch((error) => error.response);
};

export const ScheduleInterview = async (body) => {
  return await HttpServices.post(
      `${process.env.REACT_APP_DOMIN_PHP_API}/api/recruiter/schedule/${process.env.REACT_APP_VERSION_API}/interview`,
      body,
  )
      .then((data) => data)
      .catch((error) => error.response);
};

export const DeleteInterview = async ({uuid}) => {
  return await HttpServices.delete(
      `${process.env.REACT_APP_DOMIN_PHP_API}/api/recruiter/schedule/${process.env.REACT_APP_VERSION_API}/interview`,
      {
        params: {uuid},
      }
  )
      .then((data) => data)
      .catch((error) => error.response);
};

export const GetAllMeetingProviders = async ({type}) => {
    return await HttpServices.get(
        `${process.env.REACT_APP_DOMIN_PHP_API_GET}/api/helper/${process.env.REACT_APP_VERSION_API}/check-company-providers`,
        {
            params: {
                type
            },
        }
    )
        .then((data) => data)
        .catch((error) => error.response);
};

export const GetIntegrationURL = async () => {
    return await HttpServices.get(
        `${process.env.REACT_APP_DOMIN_PHP_API_GET}/api/recruiter/${process.env.REACT_APP_VERSION_API}/auth/integration`,
    )
        .then((data) => data)
        .catch((error) => error.response);
};

